const e = "numeric", n = "short", o = "long", t = {
  year: e,
  month: e,
  day: e
}, E = {
  year: e,
  month: n,
  day: e
}, T = {
  year: e,
  month: n,
  day: e,
  weekday: n
}, m = {
  year: e,
  month: o,
  day: e
}, _ = {
  year: e,
  month: o,
  day: e,
  weekday: o
}, a = {
  hour: e,
  minute: e
}, h = {
  hour: e,
  minute: e,
  second: e
}, u = {
  hour: e,
  minute: e,
  second: e,
  timeZoneName: n
}, c = {
  hour: e,
  minute: e,
  second: e,
  timeZoneName: o
}, r = {
  hour: e,
  minute: e,
  hourCycle: "h23"
}, y = {
  hour: e,
  minute: e,
  second: e,
  hourCycle: "h23"
}, s = {
  hour: e,
  minute: e,
  second: e,
  hourCycle: "h23",
  timeZoneName: n
}, I = {
  hour: e,
  minute: e,
  second: e,
  hourCycle: "h23",
  timeZoneName: o
}, d = {
  year: e,
  month: e,
  day: e,
  hour: e,
  minute: e
}, D = {
  year: e,
  month: e,
  day: e,
  hour: e,
  minute: e,
  second: e
}, i = {
  year: e,
  month: n,
  day: e,
  hour: e,
  minute: e
}, M = {
  year: e,
  month: n,
  day: e,
  hour: e,
  minute: e,
  second: e
}, S = {
  year: e,
  month: n,
  day: e,
  weekday: n,
  hour: e,
  minute: e
}, H = {
  year: e,
  month: o,
  day: e,
  hour: e,
  minute: e,
  timeZoneName: n
}, O = {
  year: e,
  month: o,
  day: e,
  hour: e,
  minute: e,
  second: e,
  timeZoneName: n
}, A = {
  year: e,
  month: o,
  day: e,
  weekday: o,
  hour: e,
  minute: e,
  timeZoneName: o
}, N = {
  year: e,
  month: o,
  day: e,
  weekday: o,
  hour: e,
  minute: e,
  second: e,
  timeZoneName: o
};
export {
  H as DATETIME_FULL,
  O as DATETIME_FULL_WITH_SECONDS,
  A as DATETIME_HUGE,
  N as DATETIME_HUGE_WITH_SECONDS,
  i as DATETIME_MED,
  M as DATETIME_MED_WITH_SECONDS,
  S as DATETIME_MED_WITH_WEEKDAY,
  d as DATETIME_SHORT,
  D as DATETIME_SHORT_WITH_SECONDS,
  m as DATE_FULL,
  _ as DATE_HUGE,
  E as DATE_MED,
  T as DATE_MED_WITH_WEEKDAY,
  t as DATE_SHORT,
  r as TIME_24_SIMPLE,
  I as TIME_24_WITH_LONG_OFFSET,
  y as TIME_24_WITH_SECONDS,
  s as TIME_24_WITH_SHORT_OFFSET,
  a as TIME_SIMPLE,
  c as TIME_WITH_LONG_OFFSET,
  h as TIME_WITH_SECONDS,
  u as TIME_WITH_SHORT_OFFSET
};
//# sourceMappingURL=contact-channels134.js.map
